import { Chip, CHIP_SIZE, CHIP_TYPE, COLORS } from '@repo/design-system/index'
import { QIcon_check_filled } from '@repo/icons/index'
import { DividerGray200 } from '../../common/Divider'

const JobSelection = ({ jobs, userJobCategoryId, onClickCategory }) => {
  //▶️ 23번 글로벌 튜터가 맨 앞으로 나오게

  // 방법 1: splice + unshift (원본 배열 변경)
  // const idx = jobs.findIndex((j) => j.id === 23)
  // if (idx > -1) {
  //   const [job23] = jobs.splice(idx, 1)
  //   jobs.unshift(job23)
  // }
  // console.log(jobs)

  // // 방법 2: filter 로 새 배열 생성 (불변)
  // const reordered = [...jobs.filter((j) => j.id === 23), ...jobs.filter((j) => j.id !== 23)]
  // console.log(reordered)

  return (
    <>
      {jobs.map((job) => {
        return (
          <div key={`job-${job.id}`} className="flex flex-col mb-[32px]">
            <div className="flex flex-row items-center">
              <div className="Body1-16Bd mb-[16px]">{job.title}</div>
              {job.id === 23 && (
                <Chip
                  className="ml-[4px] mb-[16px]"
                  type={CHIP_TYPE.ACTIONABLE}
                  size={CHIP_SIZE.SM}
                  customBgColor={COLORS.RED50}
                >
                  <Chip.Label customTxtColor={COLORS.RED400}>NEW</Chip.Label>
                </Chip>
              )}
            </div>

            {job.categories.map((item) => {
              return (
                <>
                  <div
                    key={`category-${item.job_category_id}`}
                    className="flex flex-row items-center justify-between px-[20px] w-full"
                    onClick={() => onClickCategory(job.id, item.job_category_id)}
                  >
                    <div className="flex flex-row items-center Body2-14Md text-gray-800">
                      {userJobCategoryId === item.job_category_id ? (
                        <div className="text-left Body2-14Bd text-purple-500">{item.title}</div>
                      ) : (
                        <div className="text-left Body2-14Md">{item.title}</div>
                      )}
                    </div>
                    <div>
                      {userJobCategoryId === item.job_category_id && (
                        <QIcon_check_filled width={24} height={24} color={COLORS.PURPLE500} />
                      )}
                    </div>
                  </div>
                  <DividerGray200 gray />
                </>
              )
            })}
          </div>
        )
      })}
    </>
  )
}

export default JobSelection
